import BaseAPI from '../base'

function connect(cafe_id) {
    return BaseAPI.get(`/iiko/connect/${cafe_id}`);
}

function checkStatus(cafe_id) {
    return BaseAPI.get(`/iiko/connect_status/${cafe_id}`);
}

function importMenu(cafe_id) {
    return BaseAPI.post(`/iiko/import_menu/${cafe_id}`);
}

function importWorkers(cafe_id) {
    return BaseAPI.post(`/iiko/import_workers/${cafe_id}`);
}

function importTables(cafe_id) {
    return BaseAPI.post(`/iiko/import_tables/${cafe_id}`);
}

function disconnect(cafe_id) {
    return BaseAPI.post(`/iiko/disconnect/${cafe_id}`);
}

function getProductsCache(cafe_id) {
    return BaseAPI.get(`/iiko/products/${cafe_id}`);
}

export default {
    connect,
    checkStatus,
    importMenu,
    importWorkers,
    importTables,
    disconnect,
    getProductsCache
}